function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M33 21.684h-3V18.5a1.5 1.5 0 0 0-1.5-1.5h-24A1.5 1.5 0 0 0 3 18.5v6A1.5 1.5 0 0 0 4.5 26h11.949v3H4.5A4.5 4.5 0 0 1 0 24.5v-6A4.5 4.5 0 0 1 4.5 14h24a4.5 4.5 0 0 1 4.5 4.5v3.184zM7.5 23a1.5 1.5 0 0 1 0-3h3a1.5 1.5 0 0 1 0 3h-3zm12 0a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h24a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5h-24zm0-3h24a4.5 4.5 0 0 1 4.5 4.5v6a4.5 4.5 0 0 1-4.5 4.5h-24a4.5 4.5 0 0 1-4.5-4.5v-6a4.5 4.5 0 0 1 4.5-4.5zm3 9a1.5 1.5 0 0 1 0-3h3a1.5 1.5 0 0 1 0 3h-3z"
});

var SvgDeliveryAddressChanged = function SvgDeliveryAddressChanged(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default SvgDeliveryAddressChanged;


//////////////////
// WEBPACK FOOTER
// ./src/icons/shipment-status/delivery-address-changed.svg
// module id = 128
// module chunks = 0 1